module.exports = require("bootstrap-no-fonts-no-js/css/bootstrap.css");